import React, { Component } from 'react';
import { Card, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


class HistoryTemplate extends Component {

    componentDidMount(){
        console.log(this.props);
    }

    render() {
        return (
            <Card>

                <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                    <div className="card__title">
                        <h5 className="bold-text">Resumen De Historia Clinica </h5>
                    </div>
                    
                    
                    <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                        <div className="form__form-group" style={{ margin: 10 }}>
                            <span className="form__form-group-label">Motivo de Consulta</span>
                            <div className="form__form-group-field">

                                <textarea
                                    name="textarea-resum-history"
                                    defaultValue={this.props.data.motivo_consulta}
                                    onChange={(e) => { this.props.handlerHistoryInfo('motivo_consulta', e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>

                        <div className="form__form-group" style={{ margin: 10 }}>
                            <span className="form__form-group-label">Descripcion/Interpretacion </span>
                            <div className="form__form-group-field">

                                <textarea
                                    name="textarea-audiology"
                                    defaultValue={this.props.data.descripcion}
                                    onChange={(e) => { this.props.handlerHistoryInfo('descripcion', e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>
                    <div style={{ margin: 10 }}>
                    <span className="form__form-group-label">Resultados </span>
                        <CKEditor
                            editor={ClassicEditor}
                            data={this.props.data.resultados}                            
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                this.props.handlerHistoryInfo('resultados', data);
                                //console.log({ event, editor, data });
                            }}                           
                        />
                    </div>
                    
                    <div style={{ margin: 10 }}>
                    <span className="form__form-group-label"> Parametros de Estimulacion para el Registro </span>
                        <CKEditor
                            editor={ClassicEditor}
                            data={this.props.data.parametros}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                this.setState({ parametros: data });
                                this.props.handlerHistoryInfo('parametros', data);
                                //console.log(data);
                            }}
                        />
                    </div>
                    <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                        <div className="form__form-group" style={{ margin: 10 }}>
                            <span className="form__form-group-label">Recomendaciones</span>
                            <div className="form__form-group-field">

                                <textarea
                                    name="textarea-conclusion"
                                    defaultValue={this.props.data.recomendaciones}
                                    onChange={(e) => { this.props.handlerHistoryInfo('recomendaciones', e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>

                        <div className="form__form-group" style={{ margin: 10 }}>
                            <span className="form__form-group-label">Observaciones </span>
                            <div className="form__form-group-field">

                                <textarea
                                    name="textarea-observation"
                                    defaultValue={this.props.data.observaciones}
                                    onChange={(e) => { this.props.handlerHistoryInfo('observaciones', e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>
                    <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                        <div className="form__form-group" style={{ margin: 10 }}>
                            <span className="form__form-group-label">Conclusion</span>
                            <div className="form__form-group-field">

                                <textarea
                                    name="textarea-conclusion"
                                    defaultValue={this.props.data.conclusion}
                                    onChange={(e) => { this.props.handlerHistoryInfo('conclusion', e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>

                        <div className="form__form-group" style={{ margin: 10 }}>
                            <span className="form__form-group-label">Nota </span>
                            <div className="form__form-group-field">

                                <textarea
                                    name="textarea-note"
                                    defaultValue={this.props.data.nota}
                                    onChange={(e) => { this.props.handlerHistoryInfo('nota', e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}

export default reduxForm({
    form: 'history_form', // a unique identifier for this form
})(withTranslation('common')(HistoryTemplate));